import { StrictMode } from "react"
import { QueryClient, QueryClientProvider } from "react-query"

import { BackOfficeSetup, Routes, ServiceProvider } from "@izettle/react-spa"
import { UrlType } from "@izettle/react-spa/dist/es/providers/services"

import { config } from "@/config"
import { CSSReset } from "@/css-reset"
import { EventSessionsProvider } from "@/events/event-session-provider"
import { Pages } from "@/pages/constants"
import { routes } from "@/pages/routes"

import { EventTrackingProvider } from "./events/tracking-provider"
import { PageProvider } from "./providers/page-provider"

export const App = () => {
  const queryClient = new QueryClient()
  return (
    <StrictMode>
      <BackOfficeSetup
        urls={Object.values(Pages)}
        config={config}
        sentryConfig={{ enabled: true }}
      >
        <CSSReset />
        <QueryClientProvider client={queryClient}>
          <EventSessionsProvider>
            <EventTrackingProvider isActive>
              <ServiceProvider type={UrlType.Service}>
                <PageProvider>
                  <Routes routes={routes} />
                </PageProvider>
              </ServiceProvider>
            </EventTrackingProvider>
          </EventSessionsProvider>
        </QueryClientProvider>
      </BackOfficeSetup>
    </StrictMode>
  )
}
